export default {
  nav: {
    Down: "立即下载",
    ReserveGift: "预约好礼",
    CharacterIntroduction: "角色介绍",
    Gameplay: "游戏介绍",
    AttentionFB: "充值特惠",
  },
  news: {
    NextPage: "下一页",
    PrevPage: "上一页",
    NextContent: "下一篇",
    PrevContent: "上一篇",
    Return: "返回",
    ReturnList: "返回列表",
    More: "更多",
    None: "没有了",
  },
};
